import { render, staticRenderFns } from "./ContactsPopover.vue?vue&type=template&id=775b0db6"
import script from "./ContactsPopover.vue?vue&type=script&lang=js"
export * from "./ContactsPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports